import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="pt-32 pb-20 px-6 max-w-4xl mx-auto min-h-[70vh]">
      <div className="mb-6 flex items-center gap-4">
        <div className="h-[2px] w-12 bg-lime"></div>
        <span className="font-lexend font-bold text-lime text-xs tracking-[0.4em] uppercase">LEGAL</span>
      </div>
      <h1 className="font-lexend font-extrabold text-4xl text-white mb-10 tracking-tighter uppercase italic">
        PRIVACY <span className="text-pacer-start">POLICY</span>
      </h1>
      <div className="font-inter text-[#888] space-y-6 leading-relaxed">
        <p>Last Updated: October 2026</p>
        <p>
          At PacerApp, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our application.
        </p>
        
        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">1. Information We Collect</h2>
        <p>
          We may collect information about you in a variety of ways. The information we may collect via the Application includes:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Personal Data:</strong> Personally identifiable information, such as your name, email address, and Strava profile information when you connect your account.</li>
          <li><strong>Athletic Data:</strong> Training loads, cadence, heart rate, and other telemetric data necessary to provide you with insights.</li>
        </ul>

        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">2. Use of Your Information</h2>
        <p>
          Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you to:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Create and manage your account.</li>
          <li>Analyze athletic data to optimize your performance.</li>
          <li>Improve our algorithms and app functionality.</li>
        </ul>

        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">3. Contact Us</h2>
        <p>
          If you have questions or comments about this Privacy Policy, please contact us at: support@getpacerapp.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
